import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addOptionSingleChoiceop,
  deleteSingleChoiseOption,
  updateItemQuestion,
  updateOption,
  updateSingleChoiceOp,
} from "../../Redux/Reducer/FormSlices";
import ReactQuill from "react-quill";
import optionDND from "../../Assets/optionDND.svg";
import addSingleOptionButton from "../../Assets/addSingleOptionButton.svg";
import optionTrash from "../../Assets/optionTrash.svg";

const DropDownQuestion = ({
  question,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  module,
  containerIndex,
}) => {
  const dispatch = useDispatch();

  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  const [multiOtionFocused, setMultiOptionfocused] = useState(null);

  const handleOptionTextChange = (optionIndex, option) => {
    dispatch(
      updateSingleChoiceOp({
        optionIndex,
        questionIndex,
        containerIndex,
        option,
      })
    );
  };

  const deleteSingleChoiceOp = (optionIndex) => {
    dispatch(
      deleteSingleChoiseOption({ optionIndex, questionIndex, containerIndex })
    );
  };
  const addNewOption = () => {
    dispatch(addOptionSingleChoiceop({ questionIndex, containerIndex }));
  };
  return (
    <>
      <div className="singleQuestion-Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      {/* <div className="nameAns_container" style={{ flexDirection: "column" }}>
        <div
          className="calander dropdown-select"
          style={{ paddingRight: "2%", position: "relative" }}
          onClick={() => handleDropDown()}
        >
          <p>Please select</p>
          <img src={dropdownIcon} alt="dropdownIcon" />
        </div>
      </div>
      {openDropdown && (
        <div className="drop-Drown-text">
          <textarea
            value={text}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className="drop-Drown-TextArea"
          />
        </div>
      )} */}
      <div>
        {question.options.map((data, index) => (
          <div
            className="choice-box"
            key={index}
            onClick={() => setMultiOptionfocused(data.id)}
          >
            <div>{index + 1}.</div>
            <input
              type="text"
              placeholder={`Add choice ${data.optionText}`}
              value={data.optionText}
              className="choice-input"
              onFocus={() => {
                setMultiOptionfocused(data.id); // Set focused question ID
              }}
              onChange={(e) => handleOptionTextChange(index, e.target.value)}
            />
            <img
              src={optionDND}
              alt="optionDND"
              style={{
                display: multiOtionFocused === data.id ? "block" : "none",
              }}
              className="optionTrash"
            />
            <img
              src={optionTrash}
              alt="trash"
              style={{
                display: multiOtionFocused === data.id ? "block" : "none",
              }}
              // className="optionTrash"
              onClick={() => deleteSingleChoiceOp(index)}
            />
          </div>
        ))}
        <div className="choice-box" onClick={() => addNewOption()}>
          <img src={addSingleOptionButton} alt="addSingleOptionButton" />
          <p>Add Option</p>
        </div>
      </div>
    </>
  );
};

export default DropDownQuestion;
